"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var Ably = _interopRequireWildcard(require("ably/browser/static/ably-commonjs"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _DataStore = _interopRequireWildcard(require("../../Stores/DataStore2"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _ResumeSuspendListeners = require("../../../helpers/ResumeSuspendListeners");

var _BuildConstants = require("../../../utils/BuildConstants");

var _HttpRequest = require("../../../utils/HttpRequest");

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

/**
 * Created by falknisius on 30.05.17.
 *
 *
 *
 * subscribeChannel:
 *      channelName, StoreAction
 *      handle connection in background
 *      if receive call storeAction
 *
 * Queue Consumer
 *      connect:
 *          encapsulate Ably connect
 *          get instanceId
 *          call auth server with applicationInstanceId for Ably token
 *
 *      register for event come online
 */
var RECONNECTION_TIMEOUT = 5000; // ms

var MESSAGE_HISTORY_URL = 'rest/v1/tickerMessages';

var MessageService = /*#__PURE__*/function () {
  /**
   * initialize ably connection
   * initialize message handler registry
   */
  function MessageService() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, MessageService);
    (0, _defineProperty2["default"])(this, "dataStoreListenerFn", function () {
      var newEnabled = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED);

      if (newEnabled === _this.enabled) {
        return;
      }

      _this.enabled = newEnabled;

      if (newEnabled) {
        if (!_this.appSuspended) {
          if (_this.ably) {
            console.log('ably activated via data store change, going to connect');

            _this.ably.connection.connect();
          } else {
            _this.init();
          }
        }
      } else {
        if (_this.ably) {
          console.log('ably disactivated via data store change, going to disconnect');
          _this.closeConnectionAfterResumeTimer = setTimeout(function () {
            _this.ably.connection.close();
          }, 1000);
        }
      }
    });
    (0, _defineProperty2["default"])(this, "registerChannel", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(channelName, resolveFunction) {
        var position, _channel, channel;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if already at least one callback is registered
                console.log('registerChannel', _this.subscribers);

                if (!_this.subscribers[channelName]) {
                  _context.next = 9;
                  break;
                }

                // test if registered
                position = _this.subscribers[channelName].functions.indexOf(resolveFunction); // if not registered add to other callbacks

                if (position === -1) {
                  _this.subscribers[channelName].functions.push(resolveFunction);
                } // no callback registered for this channel


                _context.next = 6;
                return _this.getChannel(channelName);

              case 6:
                _channel = _context.sent;

                if (_channel.state !== 'attached' && _channel.state !== 'attaching') {
                  _channel.subscribe(_this.subscribers[channelName].eventHandler);
                }

                return _context.abrupt("return", _channel);

              case 9:
                _context.next = 11;
                return _this.getChannel(channelName);

              case 11:
                channel = _context.sent;
                // initial subscriber structure with default handler
                _this.subscribers[channelName] = {
                  eventHandler: function eventHandler(message) {
                    _this.subscribers[channel.name].functions.forEach(function (callback, index) {
                      try {
                        callback(message, channel.name);
                      } catch (exception) {
                        console.error('Exception in handling message', message, ' on channel ', channel.name, 'function index ', index, exception);
                      }
                    });
                  },
                  functions: [resolveFunction]
                };
                channel.subscribe(_this.subscribers[channelName].eventHandler);
                return _context.abrupt("return", channel);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this.onInitializedListener = []; // initialize ably connection

    this.onChangeListeners = [];
    window.ablyConnectivity = {};
    window.ablyConnectivity.state = 'initializing';
    window.ablyConnectivity.reliable = false; // ably is reliable after first 'connected' or 'disconnected' event

    window.ablyConnectivity.addOnChangeListener = function (listener) {
      _this.onChangeListeners.push(listener);
    };

    window.ablyConnectivity.removeOnChangeListener = function (listener) {
      (0, _ArrayHelper.removeElement)(_this.onChangeListeners, listener);
    };

    this.enabled = false; // will be set correctly in init()

    this.ably = null;
    this.appSuspended = false;
    this.closeConnectionAfterResumeTimer = null;
    this.ablyConnectionIsClosing = false; // initialize message handler registry

    this.subscribers = {};
    this.connectHandlers = [];
    this.dataStoreListener = null;
    (0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
      _this.appSuspended = true;

      if (_this.ably) {
        console.log('app is suspended, disconnect from ably in 1 second from now');
        _this.closeConnectionAfterResumeTimer = setTimeout(function () {
          _this.ably.connection.close();
        }, 1000);
      }
    });
    (0, _ResumeSuspendListeners.addOnResumeListener)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              clearTimeout(_this.closeConnectionAfterResumeTimer);
              _this.appSuspended = false;
              console.log('app resumed, connect to ably', _this.enabled);

              if (!_this.enabled) {
                _context2.next = 19;
                break;
              }

              if (!_this.ably) {
                _context2.next = 18;
                break;
              }

              if (!(window.ablyConnectivity.state === 'connected')) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return (0, _TimeoutHelper.timeout)(1000);

            case 8:
              if (!_this.ablyConnectionIsClosing) {
                _context2.next = 13;
                break;
              }

              _context2.next = 11;
              return (0, _TimeoutHelper.timeout)(50);

            case 11:
              _context2.next = 8;
              break;

            case 13:
              if (!_this.appSuspended) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return");

            case 15:
              // no problem if app is offline
              _this.ably.connection.connect();

              _context2.next = 19;
              break;

            case 18:
              _this.init();

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    document.addEventListener('online', function () {
      if (_this.enabled && !_this.appSuspended) {
        if (_this.ably) {
          console.log('device is online, reconnecting ably now');

          _this.ably.connection.connect();
        } else {
          _this.init();
        }
      }
    });
  }

  (0, _createClass2["default"])(MessageService, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;

        var ablyEnabled, self, applicationInstanceId;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ablyEnabled = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED);
                console.log('messaging service init', ablyEnabled);
                this.dataStoreListener = _DataStore["default"].addOnChangeListener(function () {
                  _this2.dataStoreListenerFn();
                });
                console.log('messaging service init');
                _context3.next = 6;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED);

              case 6:
                if (_context3.sent) {
                  _context3.next = 9;
                  break;
                }

                this.enabled = false;
                return _context3.abrupt("return");

              case 9:
                this.enabled = true;
                console.log('messagingservice init getInstanceId', _config["default"].ablyApiKey);
                self = this;
                _context3.next = 14;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 14:
                applicationInstanceId = _context3.sent;
                // for logging add: log: { level: 4 },
                this.ably = new Ably.Realtime({
                  key: _config["default"].ablyApiKey,
                  clientId: applicationInstanceId,
                  queryTime: true
                });
                this.onInitializedListener.forEach(function (listener) {
                  listener();
                });
                this.ably.connection.on('initialized', function () {
                  // A Connection object having this state has been initialized but no connection has yet been attempted.
                  console.log('ably Connection initialized (no connection established)');
                });
                /**
                 * A connection attempt has been initiated. The connecting state is entered as soon as the library has completed initialization, and is reentered each time connection is re-attempted following disconnection.
                 */

                this.ably.connection.on('connecting', function () {
                  console.log('ably connecting');

                  if (window.ablyConnectivity.state !== 'disconnected' && window.ablyConnectivity.state !== 'initializing') {
                    window.ablyConnectivity.state = 'disconnected';
                    self.fireAblyChangeEvent();
                  }
                });
                /**
                 * A connection exists and is active.
                 */

                this.ably.connection.on('connected', function () {
                  console.log('ably connected');

                  if (window.ablyConnectivity.state !== 'connected') {
                    window.ablyConnectivity.state = 'connected';
                    window.ablyConnectivity.reliable = true;
                    self.fireAblyChangeEvent();
                  }

                  if (self.connectHandlers.length > 0) {
                    self.connectHandlers.forEach(function (handler) {
                      handler.call(self);
                    });
                  }
                });
                this.ably.connection.on(function (stateChange) {
                  console.log('New ably connection state is ' + stateChange.current);
                  this.ablyConnectionIsClosing = stateChange.current === 'closing';
                  window.ablyConnectivity.state = stateChange.current === 'connected' ? 'connected' : 'disconnected';

                  if (stateChange.current === 'disconnected' && !window.ablyConnectivity.reliable) {
                    window.ablyConnectivity.reliable = true;
                  }

                  self.fireAblyChangeEvent();
                });
                /**
                 * A temporary failure condition. No current connection exists because there is no network connectivity or no host is available.
                  The disconnected state is entered if an established connection is dropped, or if a connection attempt was unsuccessful. In the disconnected state the library will periodically attempt to open a new connection (approximately every 15 seconds), anticipating that the connection will be re-established soon and thus connection and channel continuity will be possible.
                  In this state, developers can continue to publish messages as they are automatically placed in a local queue, and sent as soon as a connection is established.
                 Messages published by other clients to the Ably service, whilst this client is disconnected, are queued and delivered to this client upon reconnection, so long as the connection is resumed within 2 minutes.
                  If connection state recovery is not possible following a new connection being established, all channels are detached, thus ensuring the developer is made aware that continuity on the channel was not possible. The developer is then responsible for re-attaching channels and recovering state, if required, using the history API.
                 */

                this.ably.connection.on('disconnected', function () {
                  console.log('ably disconnected but will retry');

                  if (window.ablyConnectivity.state !== 'disconnected') {
                    window.ablyConnectivity.state = 'disconnected';
                    self.fireAblyChangeEvent();
                  }
                });
                /**
                 * A long term failure condition. No current connection exists because there is no network connectivity or no host is available.
                  The suspended state is entered after a failed connection attempt if there has then been no connection for a period of two minutes. In the suspended state, the library will periodically attempt to open a new connection every 30 seconds. Developers are unable to publish messages in this state. A new connection attempt can also be triggered by an explicit call to connect on the Connection object.
                 */

                this.ably.connection.on('suspended', function () {
                  console.log('ably suspended (long term connection failure)');

                  if (window.ablyConnectivity.state !== 'disconnected') {
                    window.ablyConnectivity.state = 'disconnected';
                    self.fireAblyChangeEvent();
                  } // try again every 5 seconds


                  setTimeout(self.ably.connection.connect, RECONNECTION_TIMEOUT);
                });
                /**
                 * An explicit request by the developer to close the connection has been sent to the Ably service. If a reply is not received from Ably within a short period of time, the connection will be forcibly terminated and the connection state will become closed.
                 */

                this.ably.connection.on('closing', function () {
                  console.log('ably closing (programmatically closed)');

                  if (window.ablyConnectivity.state !== 'disconnected') {
                    window.ablyConnectivity.state = 'disconnected';
                    self.fireAblyChangeEvent();
                  }
                });
                /**
                 * The connection has been explicitly closed by the client.
                  In the closed state, no reconnection attempts are made automatically by the library, and clients may not publish messages. No connection state is preserved by the service or by the library. A new connection attempt can be triggered by an explicit call to connect on the Connection object, which will result in a new connection.
                 */

                this.ably.connection.on('closed', function () {
                  console.log('ably closed (programmatically closed)');

                  if (window.ablyConnectivity.state !== 'disconnected') {
                    window.ablyConnectivity.state = 'disconnected';
                    self.fireAblyChangeEvent();
                  }
                });
                /**
                 * An indefinite failure condition. This state is entered if a connection error has been received from the Ably service (such as an attempt to connect with invalid credentials). A failed state may also be triggered by the client library directly as a result of some local permanent error.
                  In the failed state, no reconnection attempts are made automatically by the library, and clients may not publish messages. A new connection attempt can be triggered by an explicit call to connect on the Connection object.
                 */

                this.ably.connection.on('failed', function (stateChange) {
                  console.error('ably connection failed: ' + stateChange.reason, (0, _stringify["default"])(stateChange));

                  if (window.ablyConnectivity.state !== 'disconnected') {
                    window.ablyConnectivity.state = 'disconnected';
                    self.fireAblyChangeEvent();
                  } // try again every 5 seconds


                  setTimeout(self.ably.connection.connect, RECONNECTION_TIMEOUT);
                });

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "listenOnStateChange",
    value: function listenOnStateChange(stateChangeCallback) {
      this.ably.connection.on(stateChangeCallback);
    }
  }, {
    key: "registerConnect",
    value: function () {
      var _registerConnect = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(onConnectHandler) {
        var position;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.waitForInitialized();

              case 2:
                position = this.connectHandlers.indexOf(onConnectHandler);
                if (position < 0) this.connectHandlers.push(onConnectHandler);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function registerConnect(_x3) {
        return _registerConnect.apply(this, arguments);
      }

      return registerConnect;
    }()
  }, {
    key: "unregisterConnect",
    value: function () {
      var _unregisterConnect = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(onConnectHandler) {
        var position;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.waitForInitialized();

              case 2:
                position = this.connectHandlers.indexOf(onConnectHandler);
                if (position >= 0) this.connectHandlers.splice(position, 1);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function unregisterConnect(_x4) {
        return _unregisterConnect.apply(this, arguments);
      }

      return unregisterConnect;
    }()
  }, {
    key: "fireAblyChangeEvent",
    value: function fireAblyChangeEvent() {
      this.onChangeListeners.forEach(function (listener) {
        return listener(window.ablyConnectivity.state);
      });
    }
  }, {
    key: "enterPresence",
    value: function () {
      var _enterPresence = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(channelName) {
        var data,
            channel,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
                _context6.next = 3;
                return this.waitForInitialized();

              case 3:
                _context6.next = 5;
                return this.getChannel(channelName);

              case 5:
                channel = _context6.sent;

                if (channel) {
                  channel.presence.enter(data, function (error) {
                    if (error) {
                      console.error('enter presence failed for ' + channelName);
                    } else {
                      console.log("tell enter presence for channel ".concat(channelName));
                    }
                  });
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function enterPresence(_x5) {
        return _enterPresence.apply(this, arguments);
      }

      return enterPresence;
    }()
  }, {
    key: "updatePresence",
    value: function () {
      var _updatePresence = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(channelName) {
        var data,
            channel,
            _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                data = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
                _context7.next = 3;
                return this.waitForInitialized();

              case 3:
                _context7.next = 5;
                return this.getChannel(channelName);

              case 5:
                channel = _context7.sent;

                if (channel) {
                  channel.presence.update(data, function (error) {
                    if (error) {
                      console.error('updated presence failed for ' + channelName);
                    } else {
                      console.log("tell update presence for channel ".concat(channelName));
                    }
                  });
                }

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updatePresence(_x6) {
        return _updatePresence.apply(this, arguments);
      }

      return updatePresence;
    }()
  }, {
    key: "leavePresence",
    value: function () {
      var _leavePresence = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(channelName) {
        var channel, self;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.waitForInitialized();

              case 2:
                _context8.next = 4;
                return this.getChannel(channelName);

              case 4:
                channel = _context8.sent;
                self = this;

                if (channel) {
                  channel.presence.leave();
                  console.log('tell leave presence for channel ' + channelName + ' and client ' + self.ably ? self.ably.clientId : '[no-ably-instance]');
                }

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function leavePresence(_x7) {
        return _leavePresence.apply(this, arguments);
      }

      return leavePresence;
    }()
  }, {
    key: "getPresence",
    value: function () {
      var _getPresence = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(channelName) {
        var channel;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getChannel(channelName);

              case 2:
                channel = _context9.sent;
                return _context9.abrupt("return", new _promise["default"](function (resolve, reject) {
                  channel.presence.get(function (error, members) {
                    if (error) {
                      console.error('error getting presence list', error);
                      reject(error);
                    }

                    console.log('There are ' + members.length + ' members on this channel');
                    console.log('members are', members);
                    resolve(members);
                  });
                }));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getPresence(_x8) {
        return _getPresence.apply(this, arguments);
      }

      return getPresence;
    }()
  }, {
    key: "subscribePresence",
    value: function () {
      var _subscribePresence = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(channelName, onChange) {
        var channel;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.getChannel(channelName);

              case 2:
                channel = _context10.sent;

                if (channel) {
                  channel.presence.subscribe('enter', function (member) {
                    console.log("Member ".concat(member.clientId, " / ").concat((0, _stringify["default"])(member.data), " entered"));
                    onChange();
                  });
                  channel.presence.subscribe('leave', function (member) {
                    console.log("Member ".concat(member.clientId, " / ").concat((0, _stringify["default"])(member.data), " left"));
                    onChange();
                  });
                  channel.presence.subscribe('update', function (member) {
                    console.log("Member ".concat(member.clientId, " / ").concat((0, _stringify["default"])(member.data), " updated"));
                    onChange();
                  });
                }

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function subscribePresence(_x9, _x10) {
        return _subscribePresence.apply(this, arguments);
      }

      return subscribePresence;
    }()
  }, {
    key: "unsubscribePresence",
    value: function () {
      var _unsubscribePresence = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(channelName) {
        var channel;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.getChannel(channelName);

              case 2:
                channel = _context11.sent;
                channel.presence.unsubscribe();

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function unsubscribePresence(_x11) {
        return _unsubscribePresence.apply(this, arguments);
      }

      return unsubscribePresence;
    }()
  }, {
    key: "getChannel",
    value: function () {
      var _getChannel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(channelName) {
        var attach,
            channel,
            _args12 = arguments;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                attach = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : true;
                _context12.next = 3;
                return this.waitForInitialized();

              case 3:
                channel = this.ably.channels.get(channelName);

                if (attach) {
                  if (channel.state !== 'attaching' && channel.state !== 'attached') {
                    channel.attach(function (error) {
                      if (error) {
                        console.error(channelName + ' not established.', error);
                      } else {
                        console.log("channel ".concat(channelName, " established."));
                      }
                    });
                  }
                }

                return _context12.abrupt("return", channel);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getChannel(_x12) {
        return _getChannel.apply(this, arguments);
      }

      return getChannel;
    }()
  }, {
    key: "sendMessage",
    value: function sendMessage(channel, eventName, message) {
      return new _promise["default"](function (resolve, reject) {
        channel.publish(eventName, message, function (error) {
          console.log('sendMessage', channel, eventName, message);

          if (error) {
            reject(error);
          } else {
            resolve(message);
          }
        });
      });
    }
    /**
     *
     * @param channelName
     * @param resolveFunction
     *
     * adds the resolveFunction to the list of callbacks for this channel if there is such a list
     * if not, install a default handler, add the resolveFunction to the list and touch the channel without any checks and subscribe for messages
     *
     * the resolveFunction is called with the full message {name: , data: }
     * the name is a eventName like update, data can be number, string or json
     *
     * the resolveFunction can be a storeAction
     */

  }, {
    key: "getMessageHistory",
    value: function () {
      var _getMessageHistory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(channel, startdate) {
        var channelName, token, response, messages;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                channelName = channel.split(':').pop();
                _context13.next = 4;
                return _RegisterInstance["default"].getAccessToken('logAggregate:read');

              case 4:
                token = _context13.sent;
                _context13.next = 7;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.LEDGER_HOST, "/").concat(MESSAGE_HISTORY_URL, "/").concat(channelName).concat(startdate ? "?startDate=".concat(startdate) : ''), {}, null, null, null, 'Bearer ' + token);

              case 7:
                response = _context13.sent;

                if (!(response.status === 200)) {
                  _context13.next = 15;
                  break;
                }

                messages = [];
                response.data.forEach(function (obj) {
                  messages.push(obj.message);
                });
                messages.sort(function (element1, element2) {
                  if (element1.dateCreated > element2.dateCreated) {
                    return 1;
                  }

                  if (element1.dateCreated < element2.dateCreated) {
                    return -1;
                  }

                  return 0;
                });
                return _context13.abrupt("return", messages);

              case 15:
                return _context13.abrupt("return", []);

              case 16:
                _context13.next = 21;
                break;

              case 18:
                _context13.prev = 18;
                _context13.t0 = _context13["catch"](0);
                throw _context13.t0;

              case 21:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 18]]);
      }));

      function getMessageHistory(_x13, _x14) {
        return _getMessageHistory.apply(this, arguments);
      }

      return getMessageHistory;
    }()
  }, {
    key: "checkIfChannelSubscribed",
    value: function () {
      var _checkIfChannelSubscribed = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(channelName) {
        var subscribers, channel;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                console.log('checkIfChannelSubscribed', channelName);
                subscribers = this.subscribers[channelName];
                _context14.next = 4;
                return this.getChannel(channelName, false);

              case 4:
                channel = _context14.sent;

                if (!(subscribers && subscribers.functions.length > 0 && (channel.state === 'attached' || channel.state === 'attaching'))) {
                  _context14.next = 9;
                  break;
                }

                return _context14.abrupt("return", true);

              case 9:
                return _context14.abrupt("return", false);

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function checkIfChannelSubscribed(_x15) {
        return _checkIfChannelSubscribed.apply(this, arguments);
      }

      return checkIfChannelSubscribed;
    }()
    /**
     *
     * @param channelName
     * @param resolveFunction
     *
     * looks if there is the resolveFunction in the list of subscribers for the channelName
     * if, then the function would be removed from the list
     * if the list gets empty the defaultHandler for the channel would be also removed
     */

  }, {
    key: "unregisterChannel",
    value: function () {
      var _unregisterChannel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(channelName, resolveFunction) {
        var _this3 = this;

        var channel, position, onChannelDetaching, onChannelDetached;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.ably) {
                  _context15.next = 5;
                  break;
                }

                if (!(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED) === true)) {
                  _context15.next = 4;
                  break;
                }

                console.error('[MessagingService] error in unregisterChannel: ably is not yet initialized');
                throw new Error('[MessagingService] error in unregisterChannel: ably is not yet initialized');

              case 4:
                return _context15.abrupt("return");

              case 5:
                if (!(this.subscribers[channelName] && this.subscribers[channelName].functions && this.subscribers[channelName].functions.length > 0)) {
                  _context15.next = 12;
                  break;
                }

                _context15.next = 8;
                return this.getChannel(channelName, false);

              case 8:
                channel = _context15.sent;
                position = this.subscribers[channelName].functions.indexOf(resolveFunction);

                if (position >= 0) {
                  channel.unsubscribe(this.subscribers[channelName].functions[position]);
                  this.subscribers[channelName].functions.splice(position, 1);
                }

                if (this.subscribers[channelName].functions.length === 0) {
                  if (channel.state === 'attaching' || channel.state === 'attached') {
                    onChannelDetaching = function onChannelDetaching() {
                      console.log('ably is detaching (probably after calling channel.detach())');
                      channel.off('detaching', onChannelDetaching);
                    };

                    onChannelDetached = function onChannelDetached() {
                      console.log('ably detached (probably after calling channel.detach())');
                      channel.off('detached', onChannelDetached);
                    };

                    channel.on('detaching', onChannelDetaching);
                    channel.on('detached', onChannelDetached); // ATTENTION: release has to be called in a timeout so it is not blocking this thread where the channelName gets deleted from the local subcribers

                    setTimeout(function () {
                      _this3.ably.channels.release(channelName);
                    });
                  }

                  delete this.subscribers[channelName];
                }

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function unregisterChannel(_x16, _x17) {
        return _unregisterChannel.apply(this, arguments);
      }

      return unregisterChannel;
    }()
  }, {
    key: "waitForInitialized",
    value: function () {
      var _waitForInitialized = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
        var _this4 = this;

        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!this.ably) {
                  _context16.next = 2;
                  break;
                }

                return _context16.abrupt("return");

              case 2:
                return _context16.abrupt("return", new _promise["default"](function (resolve, reject) {
                  _this4.onInitializedListener.push(function () {
                    resolve();
                  });
                }));

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function waitForInitialized() {
        return _waitForInitialized.apply(this, arguments);
      }

      return waitForInitialized;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.waitForInitialized();

              case 2:
                if (this.dataStoreListener) {
                  console.log('we got this.dataStoreListener', this.dataStoreListener);
                  this.dataStoreListener();
                }

                (0, _values["default"])(this.ably.channels.all).forEach(function (channel) {
                  channel.detach();
                });
                this.subscribers = {};

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }()
  }]);
  return MessageService;
}();

var messageService = new MessageService();
var _default = messageService;
exports["default"] = _default;